module.exports = __webpack_public_path__ + "i18n/ko.83a473d84501953887a05fbb72bea937.json";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader?name=i18n/[name].[hash].[ext]!./i18n/ko.json
// module id = 1542
// module chunks = 60